export default __webpack_public_path__ + "311496e8ad04abe016d9f23d3f5f1896.ttf";